import { appstr } from "../utils/appstr";
import { CommaDecode } from "../utils/CommaDecode";
import { CommaEncode } from "../utils/CommaEncode";
import { ConvertNull } from "../utils/ConvertNull";
import { convertStdDateString } from "../utils/convertStdDateString";
import {
  enumAssistOption,
  enumBGOption,
  enumChartTemplateSet,
  enumDataSource,
  enumIWizDataSet,
  enumObjectTypes,
  enumRefreshOption,
  enumSCDensity,
  kNameID,
  kParentPositionID,
  kPersonID,
  kPositionID,
  kPositionTitleID,
  kSupervisorID,
  kTitleID
} from "../constants";
import { QAssistantRule } from "./QAssistantRule";
import { QRule } from "./QRule";
import { QSortConfig } from "./QSortConfig";
import { QSortCriteria } from "./QSortCriteria";
import { QXMLObject } from "./QXMLObject";
import { StringToBool } from "../utils/StringToBool";
import { ConvertNullInt } from "../utils/ConvertNullInt";
import { PositionConfig } from "./PositionConfig";

export class QIWizData extends QXMLObject {
  constructor() {
    // Connector info
    super();
    this.fSrcConnector = null;
    this.fSrcFile = null;
    this.fSrcDir = null;

    //NOTE: These two flags replace the prior mechanism leveraging the data source.
    //Prior state - data source is plan, server chart, chart builder, etc.
    //Current state - Base chart ID drives the underlying source of employee data that the document
    //filters etc are applied on top of.
    //Serverchart boolean drives static or not-static employee dat (store subcharts/records in the JSON or, leave the chart
    //'living'
    this.fBaseChartID = null;
    this.fIsServerChart = false;
    this.fChartLevels = null;
    this.fDescription = null;
    this.fIsLiveChart = false;

    // Filter
    this.fFilterDataCheckState = false;
    this.fFilterRule = null;

    // Top Box
    this.fTopBoxCheckState = false;
    this.fTopBoxIDs = null;
    this.fBaseBoxCount = null;
    this.fForceTopBoxID = null;

    // Subchart Info
    this.fSubChartOption = null;
    this.fCurSubChartBreakLevels = null;
    this.fCurSubChartBreakField = null;
    this.fCurSmartBreak = null;
    this.fCurSubChartNameFieldID = null;
    this.fSmartStartLevel = null;

    // this.fAutoBreak = null;
    this.fPageDensity = enumSCDensity.standard;

    //Field mapping
    this.fMapping = null;

    this.fHierCheckState = true;

    this.fAssistWizMode = null;
    this.fUseAssistantRule = false;
    this.fAssistantRule = null;
    this.fUsePeerAssistRule = false;
    this.fPeerAssistRule = null;
    this.fStartAssistLeft = false;

    this.fDoAuxReporting = false;

    //Chart Template
    this.fChartTemplateName = null;
    this.fChartTemplateSet = null;

    //Chart Master
    this.fMPOption = null;
    this.fCurMPFile = null;
    this.fCurMPFolder = null;

    // Refresh data
    this.fRefreshOption = null;
    this.fArchiveTimeStamp = null;
    this.fPersistBranchStyle = false;
    this.fPersistBoxLayout = false;
    this.fPersistBoxSort = false;
    this.fPersistAssist = false;
    this.fPersistSubchartBreak = false;

    // Adv Options
    this.fCoHeadChart = null;
    this.fSortChart = null;
    this.fSortCriteria = null;

    this.fUseRefTable = null;
    this.fRefTableFile = null;

    this.fAppendData = null;
    this.fAppendFile = null;

    this.fRestrictData = null;
    this.fRestrictFields = null;

    this.fSAPOptions = null;
    //  this.fDoDiagnostic = false;
    //  this.fDiagnostic = null;

    this.fFieldSourceMaps = null;

    // Rename Subcharts (not persistant)
    this.fRenameSubcharts = false;
    this.fUpdateMode = null; // enumIWizDataSet.interactive;
    this.fClearPicCache = false;

    this.fPlaceHolderField = null;
    this.fPlaceHolderField2 = null;
    this.fPlaceHolder = null;
    this.fOrphans = null;
    this.fPositionConfig = null;

    // Import
    this.fImport = null;
    this.fSortOverrides = null;
  }

  InitIWizData(dataSource, updateMode) {
    // Filter
    this.fFilterDataCheckState = false;
    this.fFilterRule = null;

    // Top Box
    this.fTopBoxCheckState = false;
    this.fTopBoxIDs = null;

    // Required Fields
    this.fMapping = {};
    this.fMapping["PersonID"] = appstr("PersonID");
    this.fMapping["SupervisorID"] = appstr("SupervisorID");
    this.fMapping["Name"] = appstr("Name");
    this.fMapping["Title"] = appstr("Title");
    this.fMapping["Photo"] = appstr("Photo");

    this.fAssistWizMode = enumAssistOption.manual;
    this.fUseAssistantRule = false;
    this.fAssistantRule = null;
    this.fUsePeerAssistRule = false;
    this.fPeerAssistRule = null;
    this.fStartAssistLeft = false;

    this.fDoAuxReporting = false;
    this.fHierCheckState = true;

    // Adv Options
    this.fCoHeadChart = false;

    // SubChart
    this.fSubChartOption = null;
    this.fCurSubChartBreakLevels = "2" + " " + appstr("Levels");
    this.fCurSubChartBreakField = null;
    this.fCurSmartBreak = "5" + " " + appstr("Boxes");
    this.SetDataSource(dataSource);
    this.fCurSubChartNameFieldID = null;
    if (dataSource == enumDataSource.manual || dataSource == enumDataSource.pointintime)
      this.fCurSubChartNameFieldID = "Name";
    else this.fCurSubChartNameFieldID = null;

    this.fSmartStartLevel = appstr("Level") + " " + "2";
    this.fPageDensity = enumSCDensity.standard;
    //this.fAutoBreak = true;
    // appstr("Name");

    // Chart Template
    this.fChartTemplateName = null;
    this.fChartTemplateSet = enumChartTemplateSet.systemtemplates;

    this.fIsServerChart = false;

    // Master Page Option
    this.fMPOption = enumBGOption.custom;

    // Data Refresh
    this.fRefreshOption = null; // enumRefreshOption.stdrefresh;
    this.fUpdateMode = updateMode;
    this.fPriorDocMgr = null;

    this.fDefPageSize = null;
    this.fOrphans = null;
  }

  GetPriorDocMgr() {
    return this.fPriorDocMgr;
  }

  SetPriorDocMgr(priorDocMgr) {
    this.fPriorDocMgr = priorDocMgr;
  }

  GetSubChartOption() {
    return this.fSubChartOption;
  }

  SetSubChartOption(subChartOption) {
    this.fSubChartOption = subChartOption;
  }

  GetSubChartNameFieldID() {
    //if (this.fCurSubChartNameFieldID == null)
    //	return this.fCurName;
    return this.fCurSubChartNameFieldID;
  }

  SetSubChartNameFieldID(fieldID) {
    this.fCurSubChartNameFieldID = fieldID;
  }

  GetBreakLevels() {
    return this.fCurSubChartBreakLevels;
  }

  GetSmartStartLevel() {
    return this.fSmartStartLevel;
  }

  SetSmartStartLevel(startLevel) {
    this.fSmartStartLevel = startLevel;
  }

  GetSmartStartVal() {
    var s = this.fSmartStartLevel;
    var parts = s.split(" ");
    var n = parseInt(parts[1]);
    return n;
  }

  GetBreakLevelsVal() {
    var s = this.fCurSubChartBreakLevels;
    var parts = s.split(" ");
    var n = parseInt(parts[0]);
    return n;
  }

  SetBreakLevels(breakLevels) {
    this.fCurSubChartBreakLevels = breakLevels;
  }

  GetBreakField() {
    return this.fCurSubChartBreakField;
  }

  SetBreakField(breakField) {
    this.fCurSubChartBreakField = breakField;
  }

  GetSmartBreak() {
    return this.fCurSmartBreak;
  }

  GetSmartBreakVal() {
    var s = this.fCurSmartBreak;
    var parts = s.split(" ");
    var n = parseInt(parts[0]);
    return n;
  }

  SetSmartBreak(smartBreakBoxes) {
    this.fCurSmartBreak = smartBreakBoxes;
  }

  SetPageDensity(pageDensity) {
    this.fPageDensity = pageDensity;
  }

  GetPageDensity() {
    return this.fPageDensity;
  }

  SetDataSource(srcConnector) {
    this.fSrcConnector = srcConnector;
  }

  SetDataSourceParams(fileName, directory) {
    this.fSrcFile = fileName;
    this.fSrcDir = directory;
  }

  SetRenameSubChartsFlag(doIt) {
    this.fRenameSubcharts = doIt;
  }

  GetRenameSubChartsFlag() {
    return this.fRenameSubcharts;
  }

  //=================================================================================================
  // Refresh props only updates - Stand alone takes action after update
  SetUpdateMode(updateMode) {
    this.fUpdateMode = updateMode;
  }

  GetUpdateMode() {
    return this.fUpdateMode;
  }

  //=================================================================================================
  // SourceInfo
  GetDataSource() {
    return this.fSrcConnector;
  }

  GetSourceFile() {
    return this.fSrcFile;
  }

  GetSourceDirectory() {
    return this.fSrcDir;
  }

  GetFieldSourceMaps() {
    return this.fFieldSourceMaps;
  }

  SetFieldSourceMaps(fieldSourceMaps) {
    this.fFieldSourceMaps = fieldSourceMaps;
  }

  //=================================================================================================
  // Filter
  GetFilterData() {
    return this.fFilterDataCheckState;
  }

  SetFilterData(filterData) {
    this.fFilterDataCheckState = filterData;
  }

  GetFilterRule() {
    return this.fFilterRule;
  }

  SetFilterRule(rule) {
    this.fFilterRule = rule;
  }

  //TODO: Need to be good at data management here. Setting to 2 as default to keep moving for now.
  GetChartLevels() {
    return this.fChartLevels ? this.fChartLevels : 2;
  }

  SetChartLevels(chainLevels) {
    this.fChartLevels = chainLevels;
  }

  //=================================================================================================
  // Top Box
  GetSpecifyTopBox() {
    return this.fTopBoxCheckState;
  }

  SetSpecifyTopBox(userTopBox) {
    this.fTopBoxCheckState = userTopBox;
  }

  GetTopBoxIDs() {
    return this.fTopBoxIDs;
  }

  SetTopBoxIDs(topBoxIDs) {
    return (this.fTopBoxIDs = topBoxIDs);
  }

  GetForceTopBoxID() {
    return this.fForceTopBoxID;
  }

  SetForceTopBoxID(forceTopBoxID) {
    this.fForceTopBoxID = forceTopBoxID;
  }

  GetBaseBoxCount() {
    return this.fBaseBoxCount;
  }

  SetBaseBoxCount(boxcount) {
    this.fBaseBoxCount = boxcount;
  }

  GetOrphans() {
    return this.fOrphans;
  }

  SetOrphans(orphans) {
    this.fOrphans = orphans;
  }

  //=================================================================================================
  // Advanced Options
  IsCoHeadChart() {
    return this.fCoHeadChart;
  }

  SetCoHeadChart(coHeadChart) {
    this.fCoHeadChart = coHeadChart;
  }

  SetSortChart(sortChart) {
    this.fSortChart = sortChart;
  }

  GetSortChart() {
    return this.fSortChart;
  }

  SetSortCriteria(sortCriteria) {
    //This is actually sort CONFIG not sort CRITERIA
    this.fSortCriteria = sortCriteria.Clone();
  }

  GetSortCriteria() {
    return this.fSortCriteria;
  }

  GetSortOverrides() {
    return this.fSortOverrides;
  }

  SetSortOverrides(overrides) {
    this.fSortOverrides = overrides;
  }

  SetSortOverrideForParent(parentRecordID, childRecordIDs) {
    if (!this.fSortOverrides) this.fSortOverrides = {};
    this.fSortOverrides[parentRecordID] = childRecordIDs;
  }

  ClearSortOverrideForParent(parentRecordID) {
    if (!this.fSortOverrides) return;
    delete this.fSortOverrides[parentRecordID];
    if (Object.keys(this.fSortOverrides).length === 0) this.fSortOverrides = null;
  }

  ClearAllSortOverrides() {
    this.fSortOverrides = null;
  }

  // Reference Tables
  SetUseRefTable(useTable) {
    this.fUseRefTable = useTable;
  }

  GetUseRefTable() {
    return this.fUseRefTable;
  }

  SetRefTableFile(filename) {
    this.fRefTableFile = filename;
  }

  GetRefTableFile() {
    return this.fRefTableFile;
  }

  // Append Data
  SetAppendData(appendData) {
    this.fAppendData = appendData;
  }

  GetAppendData() {
    return this.fAppendData;
  }

  SetAppendFile(filename) {
    this.fAppendFile = filename;
  }

  GetAppendFile() {
    return this.fAppendFile;
  }

  GetAppendFileList() {
    var files = this.GetAppendFile();
    var fileList = files ? files.split(",") : [];
    fileList = fileList.filter(function (x) {
      if (x.trim() != "") return x;
    });
    return fileList;
  }

  GetPlaceHolder() {
    return this.fPlaceHolder;
  }

  SetPlaceHolder(isChecked) {
    this.fPlaceHolder = isChecked;
  }

  GetPlaceHolderField() {
    return this.fPlaceHolderField;
  }

  SetPlaceHolderField(fieldname) {
    this.fPlaceHolderField = fieldname;
  }

  GetPlaceHolderField2() {
    return this.fPlaceHolderField2;
  }

  SetPlaceHolderField2(fieldname2) {
    this.fPlaceHolderField2 = fieldname2;
  }

  // Restrict Data
  SetRestrictData(restrictData) {
    this.fRestrictData = restrictData;
  }

  GetRestrictData() {
    return this.fRestrictData;
  }

  SetRestrictFields(fieldList) {
    this.fRestrictFields = fieldList;
  }

  GetRestrictFields() {
    return this.fRestrictFields;
  }

  // SAP Options
  SetSAPOptions(sapOptions) {
    this.fSAPOptions = sapOptions;
  }

  GetSAPOptions() {
    return this.fSAPOptions;
  }

  SetClearPicCache(clearPicCache) {
    this.fClearPicCache = clearPicCache;
  }

  GetClearPicCache() {
    return this.fClearPicCache;
  }

  //=================================================================================================
  // Required Fields
  GetHasHierarchy() {
    return this.fHierCheckState;
  }

  GetIDField(objType = enumObjectTypes.holder) {
    const key = objType === enumObjectTypes.holder ? kPersonID : kPositionID;
    return this.fMapping[key];
  }

  GetSuperField(objType = enumObjectTypes.holder) {
    const key = objType === enumObjectTypes.holder ? kSupervisorID : kParentPositionID;
    return this.fMapping[key];
  }

  GetNameField(objType = enumObjectTypes.holder) {
    const key = objType === enumObjectTypes.holder ? kNameID : kPositionTitleID;
    return this.fMapping[key];
  }

  GetTitleField(objType = enumObjectTypes.holder) {
    const key = objType === enumObjectTypes.holder ? kTitleID : kPositionTitleID;
    return this.fMapping[key];
  }

  SetAuxField(auxField) {
    this.fMapping["AuxSuperID"] = auxField;
  }

  GetAuxField() {
    return this.fMapping["AuxSuperID"];
  }

  SetAuxField2(auxField2) {
    this.fMapping["AuxSuperID2"] = auxField2;
  }

  GetAuxField2() {
    return this.fMapping["AuxSuperID2"];
  }

  GetPhotoField() {
    return this.fMapping["Photo"];
  }

  SetHasHierarchy(hasHierarchy) {
    this.fHierCheckState = hasHierarchy;
  }

  SetIDField(idField) {
    this.fMapping["PersonID"] = idField;
  }

  SetSuperField(superField) {
    this.fMapping["SupervisorID"] = superField;
  }

  SetNameField(nameField) {
    this.fMapping["Name"] = nameField;
  }

  SetTitleField(titleField) {
    this.fMapping["Title"] = titleField;
  }

  SetPhotoField(photoField) {
    this.fMapping["Photo"] = photoField;
  }

  // For loading from existing metadata
  SetFieldMapping(mapping) {
    this.fMapping = mapping;
  }

  // Start - Assistant automation
  GetAssistWizMode() {
    return this.fAssistWizMode;
  }

  SetAssistWizMode(wizMode) {
    this.fAssistWizMode = wizMode;
  }

  GetUseAssistantRule() {
    return this.fUseAssistantRule;
  }

  SetUseAssistantRule(useAssistantRule) {
    this.fUseAssistantRule = useAssistantRule;
  }

  GetUsePeerAssistRule() {
    return this.fUsePeerAssistRule;
  }

  SetUsePeerAssistRule(usePeerAssistRule) {
    this.fUsePeerAssistRule = usePeerAssistRule;
  }

  GetAssistantRule() {
    return this.fAssistantRule;
  }

  SetAssistantRule(assistantRule) {
    this.fAssistantRule = assistantRule;
  }

  GetPeerAssistRule() {
    return this.fPeerAssistRule;
  }

  SetPeerAssistRule(peerAssistRule) {
    this.fPeerAssistRule = peerAssistRule;
  }

  GetStartAssistLeft() {
    return this.fStartAssistLeft;
  }

  SetStartAssistLeft(setStartLeft) {
    this.fStartAssistLeft = setStartLeft;
  }

  // End - Assistant automation
  GetDoAuxReporting() {
    return this.fDoAuxReporting;
  }

  SetDoAuxReporting(doIt) {
    this.fDoAuxReporting = doIt;
  }

  //=================================================================================================
  // Chart Template
  GetChartTemplateID() {
    //This is an ID! not a name.
    return this.fChartTemplateName;
  }

  SetChartTemplateName(templateName) {
    //TODO: Update this name and reference to really mean ID. It's all ID under the hood.
    this.fChartTemplateName = templateName;
  }

  GetDescription() {
    return this.fDescription;
  }

  SetDescription(description) {
    this.fDescription = description;
  }

  GetChartTemplateSet() {
    return this.fChartTemplateSet;
  }

  SetSelectedADPProfile(profile) {
    this.fProfileADP = profile;
  }

  GetArchiveTimeStamp() {
    return this.fArchiveTimeStamp;
  }

  GetArchiveString(wsMgr) {
    var pitInfo = wsMgr.GetPointInTime();
    var oi = wsMgr.GetOrgInfo();

    var timeStamp = this.GetArchiveTimeStamp();
    if (timeStamp == null && pitInfo == null) {
      return appstr("No Date Found");
    }

    var timeString = pitInfo != null ? pitInfo["hotdate"] : timeStamp;

    var splitResult = timeString.split(":");
    var dateStr = splitResult[0];
    var timeStr = splitResult[1];
    if (timeStr && timeStr.length !== 4) timeStr = null;
    var dateObj = convertStdDateString(dateStr, timeStr);

    return dateObj.FormatDate(oi.GetDateFormat());
  }

  SetArchiveTimestamp(ArchiveTimeStamp) {
    this.fArchiveTimeStamp = ArchiveTimeStamp;
  }

  SetChartTemplateSet(templateSet) {
    this.fChartTemplateSet = templateSet;
  }

  //=================================================================================================
  //  Master Page
  GetMasterOption() {
    return this.fMPOption;
  }

  SetMasterOption(masterOption) {
    this.fMPOption = masterOption;
  }

  GetMasterFolder() {
    return this.fCurMPFolder;
  }

  SetMasterFolder(masterFolder) {
    this.fCurMPFolder = masterFolder;
  }

  GetMasterFile() {
    return this.fCurMPFile;
  }

  SetMasterFile(masterFile) {
    this.fCurMPFile = masterFile;
  }

  SetDefaultBackground(backgroundFile) {
    this.fDefaultBackground = backgroundFile;
  }

  GetDefaultBackground() {
    return this.fDefaultBackground;
  }

  //=================================================================================================
  GetPersistBranchStyle() {
    return true;
  }

  SetPersistBranchStyle(persist) {
    this.fPersistBranchStyle = persist;
  }

  GetPersistBoxLayout() {
    return this.fPersistBoxLayout;
  }

  SetPersistBoxLayout(persist) {
    this.fPersistBoxLayout = persist;
  }

  GetPersistBoxSort() {
    return this.fPersistBoxSort;
  }

  SetPersistBoxSort(persist) {
    this.fPersistBoxSort = persist;
  }

  GetPersistAssist() {
    return this.fPersistAssist;
  }

  SetPersistAssist(persist) {
    this.fPersistAssist = persist;
  }

  GetPersistSCBreak() {
    return this.fPersistSubchartBreak;
  }

  SetPersistSCBreak(persist) {
    this.fPersistSubchartBreak = persist;
  }

  GetBaseChartID() {
    return this.fBaseChartID;
  }

  SetBaseChartID(chartID) {
    this.fBaseChartID = chartID;
  }

  GetIsServerChart() {
    return this.fIsServerChart;
  }

  SetIsServerChart(isserverchart) {
    this.fIsServerChart = isserverchart;
  }

  GetIsLiveChart() {
    return this.fIsLiveChart;
  }

  SetIsLiveChart(islivechart) {
    this.fIsLiveChart = islivechart;
  }

  SetAutoSyncSchedule(syncObject) {
    this.fAutoSyncSchedule = syncObject;
  }

  GetAutoSyncSchedule() {
    return this.fAutoSyncSchedule;
  }

  //=================================================================================================
  // Import

  SetImport(importObject) {
    this.fImport = importObject;
  }

  GetImport() {
    return this.fImport;
  }

  //=================================================================================================
  // Clone
  Clone() {
    var c = new QIWizData();
    c.fSrcConnector = this.fSrcConnector;
    c.fSrcFile = this.fSrcFile;
    c.fSrcDir = this.fSrcDir;

    c.fBaseChartID = this.fBaseChartID;
    c.fIsServerChart = this.fIsServerChart;
    c.fChartLevels = this.fChartLevels;

    // Filter
    c.fFilterDataCheckState = this.fFilterDataCheckState;
    c.fFilterRule = this.fFilterRule?.Clone() || null;
    c.fPlaceHolder = this.fPlaceHolder;
    c.fPlaceHolderField = this.fPlaceHolderField;
    c.fPlaceHolderField2 = this.fPlaceHolderField2;

    // Top Box
    c.fTopBoxCheckState = this.fTopBoxCheckState;
    c.fTopBoxIDs = this.fTopBoxIDs;
    c.fForceTopBoxID = this.fForceTopBoxID;

    // Subchart Info
    c.fSubChartOption = this.fSubChartOption;
    c.fCurSubChartBreakLevels = this.fCurSubChartBreakLevels;
    c.fCurSubChartBreakField = this.fCurSubChartBreakField;
    c.fCurSmartBreak = this.fCurSmartBreak;
    c.fCurSubChartNameFieldID = this.fCurSubChartNameFieldID;
    c.fSmartStartLevel = this.fSmartStartLevel;
    //c.fAutoBreak = this.fAutoBreak;
    c.fPageDensity = this.fPageDensity;

    //Required Fields
    c.fMapping = JSON.parse(JSON.stringify(this.fMapping));

    c.fHierCheckState = this.fHierCheckState;

    // Assistants
    c.fAssistWizMode = this.fAssistWizMode;
    c.fUseAssistantRule = this.fUseAssistantRule;
    c.fAssistantRule = this.fAssistantRule ? this.fAssistantRule.Clone() : null;

    c.fUsePeerAssistRule = this.fUsePeerAssistRule;
    c.fPeerAssistRule = this.fPeerAssistRule ? this.fPeerAssistRule.Clone() : null;
    if (c.fPeerAssistRule) c.fPeerAssistRule.SetXMLElementName("peerrule");

    c.fStartAssistLeft = this.fStartAssistLeft;

    c.fDoAuxReporting = this.fDoAuxReporting;

    // Level Chart
    c.fCoHeadChart = this.fCoHeadChart;

    // Sort
    c.fSortChart = this.fSortChart;
    var curSort = this.fSortCriteria;
    if (curSort) c.fSortCriteria = curSort.Clone();

    // Ref Table
    c.fUseRefTable = this.fUseRefTable;
    c.fRefTableFile = this.fRefTableFile;

    // Append Data
    c.fAppendData = this.fAppendData;
    c.fAppendFile = this.fAppendFile;

    // Restrict Data
    c.fRestrictData = this.fRestrictData;
    c.fRestrictFields = this.fRestrictFields;

    // SAP Options
    c.fSAPOptions = this.fSAPOptions;

    //Chart Template
    c.fChartTemplateName = this.fChartTemplateName;
    c.fChartTemplateSet = this.fChartTemplateSet;

    // Master Page
    c.fMPOption = this.fMPOption;
    c.fCurMPFile = this.fCurMPFile;
    c.fCurMPFolder = this.fCurMPFolder;

    // Refresh Data Options
    c.fRefreshOption = this.fRefreshOption;
    c.fArchiveTimeStamp = this.fArchiveTimeStamp;
    c.fPersistBranchStyle = this.fPersistBranchStyle;
    c.fPersistBoxLayout = this.fPersistBoxLayout;
    c.fPersistBoxSort = this.fPersistBoxSort;
    c.fPersistAssist = this.fPersistAssist;
    c.fPersistSubchartBreak = this.fPersistSubchartBreak;

    c.fUpdateMode = this.fUpdateMode;
    c.fPriorDocMgr = this.fPriorDocMgr;
    c.fClearPicCache = this.fClearPicCache;

    c.fDescription = this.fDescription;
    c.fBaseBoxCount = this.fBaseBoxCount;
    c.fOrphans = this.fOrphans;

    c.fIsLiveChart = this.fIsLiveChart;
    c.fIsPlanChart = this.fIsPlanChart;
    c.fAutoSyncSchedule = this.fAutoSyncSchedule;
    c.fIsAutoSave = this.fIsAutoSave;
    c.fDefaultBackground = this.fDefaultBackground;
    c.fPositionConfig = this.fPositionConfig;
    c.fFieldSourceMaps = this.fFieldSourceMaps;
    c.fImport = this.fImport;
    if (this.fSortOverrides) c.fSortOverrides = JSON.parse(JSON.stringify(this.fSortOverrides));
    return c;
  }

  //=================================================================================================
  // Save
  OutputSubElements(stream) {
    this.OutputElementTriple("conninfo", this.fSrcConnector, this.fSrcFile, this.fSrcDir, stream);
    this.OutputElementQuad(
      "filter2",
      this.fFilterDataCheckState,
      this.fCurFilterField,
      this.fCurFilterComp,
      this.fIncludeSubsState,
      stream
    );
    this.OutputSimpleElement("filterval", this.fCurFilterValue, stream);
    this.OutputSimpleElement("complex", this.fComplexFilter, stream);
    this.OutputSimpleElement("complexdef", this.fComplexFilterDef, stream);
    this.OutputSimpleElement("complexsub", this.fComplexSubFilter, stream);
    this.OutputSimpleElement("complexsubdef", this.fComplexSubFilterDef, stream);
    this.OutputSimpleElement("profileadp", this.fProfileADP, stream);
    this.OutputSimpleElement("archivedate", this.fArchiveTimeStamp, stream);

    var ids = this.fTopBoxIDs;
    if (ids) ids = ids.split(",").join("^");
    this.OutputElementPair("topbox", this.fTopBoxCheckState, ids, stream);
    this.OutputSimpleElement("chain", this.fChainLevels, stream);
    this.OutputSimpleElement("includef", this.fIncludeFiltered, stream);

    this.OutputElementSex(
      "subchart",
      this.fSubChartOption,
      this.fCurSubChartBreakLevels,
      this.fCurSubChartBreakField,
      this.fCurSmartBreak,
      this.fCurSubChartNameFieldID,
      this.fSmartStartLevel,
      stream
    );
    //this.OutputSimpleElement("autobreak", this.fAutoBreak, stream);
    this.OutputSimpleElement("scdense", this.fPageDensity, stream);

    /*
    var v0 = CommaEncode(this.fCurID);
    var v1 = CommaEncode(this.fCurSuperID);
    var v2 = CommaEncode(this.fCurName);
    var v3 = CommaEncode(this.fCurTitle);
	this.OutputElementQuin("reqfields", v0,  v1, v2, v3,this.fHierCheckState, stream);
	*/
    var mapping = JSON.stringify(this.fMapping);

    this.OutputSimpleElement("mapping", mapping, stream);

    this.OutputSimpleElement("usehier", this.fHierCheckState, stream);

    this.OutputSimpleElement("assistmode", this.fAssistWizMode, stream);
    this.OutputSimpleElement("useassistrule", this.fUseAssistantRule, stream);
    this.OutputSimpleElement("usepeerassistrule", this.fUsePeerAssistRule, stream);
    this.OutputSimpleElement("assistleft", this.fStartAssistLeft, stream);

    this.OutputSimpleElement("doAuxReporting", this.fDoAuxReporting, stream);

    //	this.OutputElementPair("ctemplate", this.fChartTemplateName,  this.fChartTemplateSet, stream);
    this.OutputSimpleElement("ctemplate2", this.fChartTemplateName, stream);
    this.OutputSimpleElement("ctemplateset", this.fChartTemplateSet, stream);

    this.OutputElementTriple("master", this.fMPOption, this.fCurMPFile, this.fCurMPFolder, stream);

    //this.OutputSimpleElement("refresh", this.fRefreshOption, stream);
    //	this.OutputElementQuad("refresh2", this.fPersistBranchStyle,this.fPersistBoxLayout,this.fPersistAssist,this.fPersistSubchartBreak, stream);
    this.OutputElementQuin(
      "refresh3",
      this.fPersistBranchStyle,
      this.fPersistBoxLayout,
      this.fPersistAssist,
      this.fPersistSubchartBreak,
      this.fPersistBoxSort,
      stream
    );

    this.OutputSimpleElement("cohead", this.fCoHeadChart, stream);
    this.OutputSimpleElement("sortchart", this.fSortChart, stream);

    if (this.fUseRefTable)
      this.OutputElementPair("reftable", this.fUseRefTable, this.fRefTableFile, stream);

    if (this.fAppendData)
      this.OutputElementPair("appenddata", this.fAppendData, this.fAppendFile, stream);
    if (this.fPlaceHolder) this.OutputSimpleElement("placeholder", this.fPlaceHolder, stream);
    this.OutputElementPair(
      "placeholderfields",
      this.fPlaceHolderField,
      this.fPlaceHolderField2,
      stream
    );

    if (this.fRestrictData) {
      var cfields = CommaEncode(this.fRestrictFields);
      this.OutputSimpleElement("restrict", this.fRestrictData, stream);
      this.OutputElementList("restrictdata", cfields, stream);
    }
    this.OutputSimpleElement("chartaccess", this.fChartAccess, stream);

    if (this.fSAPOptions != null) this.OutputSimpleElement("sapoption", this.fSAPOptions, stream);
  }

  LoadFromJSON(json) {
    var connInfo = json["connectionInfo"];
    this.fSrcConnector = connInfo["source"];
    this.fSrcFile = connInfo["filename"];
    this.fSrcDir = connInfo["directory"];

    this.fBaseChartID = json["baseChartID"];
    this.fChartLevels = json["chartLevels"];
    this.fIsServerChart = json["isServerChart"];
    this.fDescription = json["description"];
    this.fBaseBoxCount = json["boxcount"];
    this.fOrphans = json["orphans"];
    var filterInfo = json["filterInfo"];
    if (filterInfo) {
      this.fFilterDataCheckState = filterInfo["enabled"] == true;
      const rule = new QRule();
      if (filterInfo["rule"]) {
        this.fFilterRule = rule.LoadFromJSON(filterInfo["rule"]);
      }
      this.fChainLevels = filterInfo["chainLevels"]; //TODO: Should this be inside filters?
      this.fIncludeFiltered = filterInfo["includeFiltered"];
    }

    var topboxinfo = json["topBoxInfo"];
    if (topboxinfo) {
      this.fTopBoxCheckState = topboxinfo["checked"];
      this.fTopBoxIDs = topboxinfo["IDs"];
    }

    var subChartInfo = json["subchartInfo"];
    if (subChartInfo) {
      this.fSubChartOption = subChartInfo["subChartOption"];
      this.fCurSubChartBreakLevels = subChartInfo["breakLevels"];
      this.fCurSubChartBreakField = subChartInfo["breakField"];
      this.fCurSmartBreak = subChartInfo["smartBreak"];
      this.fCurSubChartNameFieldID = subChartInfo["nameField"];
      this.fSmartStartLevel = subChartInfo["smartStartLevel"];
    }

    //TODO???
    this.fSCPageDensity = json["scPageDensity"];

    this.fMapping = json["mapping"];
    this.fHierCheckState = json["useHier"];

    if (json["assistantInfo"]) {
      var assistantInfo = json["assistantInfo"];
      this.fAssistWizMode = assistantInfo["mode"];
      this.fUseAssistantRule = assistantInfo["useAssistantRule"];
      this.fUsePeerAssistRule = assistantInfo["usePeerAssistRule"];
      this.fStartAssistLeft = assistantInfo["assistLeft"];
    }
    this.fArchiveTimeStamp = json["archiveDate"];

    this.fDoAuxReporting = json["doAuxReporting"];

    this.fCoHeadChart = json["isCohead"];

    this.fSortChart = json["sortChart"];

    this.fUseRefTable = false;
    if (json["refTable"]) {
      this.fUseRefTable = json["refTable"]["enabled"];
      this.fRefTableFile = json["refTable"]["filePath"];
    }

    this.fAppendData = false;
    if (json["appendData"]) {
      this.fAppendData = json["appendData"]["appendData"];
      this.fAppendFile = json["appendData"]["filePath"];
    }

    if (json["placeHolder"]) {
      this.fPlaceHolder = json["placeHolder"]["doPlaceholder"];
      this.fPlaceHolderField = json["placeHolder"]["fields"]["fieldID1"];
      this.fPlaceHolderField2 = json["placeHolder"]["fields"]["fieldID2"];
    }

    if (json["restrictData"]) {
      this.fRestrictData = json["restrictData"]["doRestrict"];
      this.fRestrictFields = json["restrictData"]["fields"];
    }

    this.fSAPOptions = json["sapOptions"];

    //Chart template name, chart template set
    if (json["curView"]) {
      this.fChartTemplateSet = json["curView"]["viewSet"];
      this.fChartTemplateName = json["curView"]["viewID"];
    }

    var backgroundSettings = json["backgroundSettings"];

    this.fCurMPFile = ConvertNull(backgroundSettings["curFile"]);
    this.fCurMPFolder = ConvertNull(backgroundSettings["curFolder"]);
    this.fMPOption = parseInt(backgroundSettings["option"]);

    var persistSettings = json["persistSettings"];
    if (persistSettings) {
      this.fPersistBranchStyle = persistSettings["branchStyles"];
      this.fPersistBoxLayout = persistSettings["boxLayouts"];
      this.fPersistBoxSort = persistSettings["sort"];
      this.fPersistAssist = persistSettings["assistants"];
      this.fPersistSubchartBreak = persistSettings["breaks"];
    }
    this.fIsLiveChart = json["liveChart"] === true;
    this.fIsAutoSave = json["autoSaveEnabled"] === true;

    var fieldSourceMap = json["fieldSourceMaps"];
    if (fieldSourceMap) {
      this.fFieldSourceMaps = json["fieldSourceMaps"];
    }

    var positionConfig = json["positionConfig"];
    if (positionConfig?.positionConfig) {
      var newPositionConfig = new PositionConfig();
      newPositionConfig.positionConfig = newPositionConfig;

      this.fPositionConfig = newPositionConfig;
    }

    var importConfig = json["import"];
    if (importConfig) {
      this.fImport = importConfig;
    }

    var sortOverrides = json["sortOverrides"];
    if (sortOverrides) {
      this.fSortOverrides = JSON.parse(JSON.stringify(sortOverrides));
    }
  }

  OutputToJSONBackground() {
    var json = {};
    json["connectionInfo"] = {
      source: enumDataSource.background,
      filename: this.fSrcFile,
      directory: this.fSrcDir
    };
    json["isServerChart"] = false;
    json["backgroundSettings"] = {
      option: this.fMPOption,
      curFile: this.fCurMPFile,
      curFolder: this.fCurMPFolder
    };
    return json;
  }

  OutputToJSON() {
    //What a mess.
    var json = {}; //Because iwiz is instantiated multiple times, the caller defines the key name.
    json["connectionInfo"] = {
      source: this.fSrcConnector,
      filename: this.fSrcFile,
      directory: this.fSrcDir
    };

    json["baseChartID"] = this.fBaseChartID;
    json["chartLevels"] = this.fChartLevels;
    json["isServerChart"] = this.fIsServerChart;
    json["description"] = this.fDescription;
    json["boxcount"] = this.fBaseBoxCount;
    json["orphans"] = this.fOrphans;

    var filterInfo = {};
    filterInfo["enabled"] = this.fFilterDataCheckState; //TODO: Are we storing JSON filters elsewhere in a more streamlined way?
    if (this.fFilterRule) {
      filterInfo["rule"] = this.fFilterRule.OutputToJSON();
    }

    json["filterInfo"] = filterInfo;

    var archiveInfo = {};
    archiveInfo["archiveDate"] = this.fArchiveTimeStamp;

    json["topBoxInfo"] = {
      checked: this.fTopBoxCheckState,
      IDs: this.fTopBoxIDs
    };

    filterInfo["chainLevels"] = this.fChainLevels;
    filterInfo["includeFiltered"] = this.fIncludeFiltered;

    json["subchartInfo"] = {
      subChartOption: this.fSubChartOption,
      breakLevels: this.fCurSubChartBreakLevels,
      breakField: this.fCurSubChartBreakField,
      smartBreak: this.fCurSmartBreak,
      nameField: this.fCurSubChartNameFieldID
    }; //TODO: Match format used for master charts.
    json["subchartInfo"]["smartStartLevel"] = this.fSmartStartLevel;

    json["mapping"] = this.fMapping;

    json["useHier"] = this.fHierCheckState;

    var assistInfo = {
      mode: this.fAssistWizMode,
      useAssistantRule: this.fUseAssistantRule,
      usePeerAssistRule: this.fUsePeerAssistRule,
      assistLeft: this.fStartAssistLeft
    };
    json["assistantInfo"] = assistInfo;

    json["doAuxReporting"] = this.fDoAuxReporting; //This is somewhat redundant. It's a mirror of having field ID tags for aux fields.

    json["curView"] = {
      viewSet: this.fChartTemplateSet,
      viewID: this.fChartTemplateName
    };

    json["backgroundSettings"] = {
      option: this.fMPOption,
      curFile: this.fCurMPFile,
      curFolder: this.fCurMPFolder
    };

    json["persistSettings"] = {
      doBranch: this.fPersistBranchStyle,
      doLayouts: this.fPersistBoxLayout,
      doAssistants: this.fPersistAssist,
      doBreaks: this.fPersistSubchartBreak,
      doSort: this.fPersistBoxSort
    }; //TODO: This should probably be tweaked

    json["isCohead"] = this.fCoHeadChart; //TODO: Better location?
    json["sortChart"] = this.fSortChart; //TODO: Better location?

    if (this.fUseRefTable)
      json["refTable"] = {
        enabled: this.fUseRefTable,
        filePath: this.fRefTableFile
      }; //LEGACY!

    if (this.fAppendData)
      json["appendData"] = {
        enabled: this.fAppendData,
        filePath: this.fAppendFile
      }; //LEGACY!

    if (this.fPlaceHolder)
      json["placeHolder"] = {
        doPlaceholder: this.fPlaceHolder,
        fields: {
          fieldID1: this.fPlaceHolderField,
          fieldID2: this.fPlaceHolderField2
        }
      };

    if (this.fRestrictData)
      json["restrictData"] = {
        doRestrict: this.fRestrictData,
        fields: this.fRestrictFields
      }; //Legacy approach for restricted fields/predecessor to true RLS/BLS.

    if (this.fSAPOptions != null)
      //Effectively legacy, but this should move anyway to something connector specific.
      json["sapOptions"] = this.fSAPOptions;

    if (this.fSortCriteria)
      //this is QSortCriteria
      json["sortCriteria"] = this.fSortCriteria.OutputToJSON(json);

    if (this.fAssistantRule)
      //This is a QRule
      json["assistantRule"] = this.fAssistantRule.OutputToJSON();

    if (this.fPeerAssistRule) json["peerAssistantRule"] = this.fPeerAssistRule.OutputToJSON();

    json["persistSettings"] = {
      branchStyles: this.fPersistBranchStyle,
      boxLayouts: this.fPersistBoxLayout,
      assistants: this.fPersistAssist,
      breaks: this.fPersistSubchartBreak,
      sort: this.fPersistBoxSort
    };

    json["liveChart"] = this.fIsLiveChart === true;
    json["autoSaveEnabled"] = this.fIsAutoSave === true;
    if (this.fFieldSourceMaps) {
      json["fieldSourceMaps"] = this.fFieldSourceMaps;
    }
    if (this.fPositionConfig?.positionConfig) {
      json["positionConfig"] = this.fPositionConfig.positionConfig;
    }
    if (this.fImport) {
      json["import"] = this.fImport;
    }
    if (this.fSortOverrides) {
      json["sortOverrides"] = this.fSortOverrides;
    }
    return json;
  }

  MapRefreshOption(refreshOption) {
    switch (refreshOption) {
      case enumRefreshOption.smartrefresh:
        this.fPersistBranchStyle = true;
        this.fPersistBoxLayout = false;
        this.fPersistBoxSort = true;
        this.fPersistAssist = true;
        this.fPersistSubchartBreak = true;
        break;
      case enumRefreshOption.stdrefresh:
        break;
      case enumRefreshOption.customrefresh:
        this.fPersistBranchStyle = true;
        this.fPersistBoxLayout = true;
        this.fPersistBoxSort = true;
        this.fPersistAssist = true;
        this.fPersistSubchartBreak = true;
        break;
    }
  }

  //var enumRefreshOption = { smartrefresh:0, stdrefresh:1, customrefresh: 2};
  LoadFilter(objTree) {
    let filterRule = new QRule();
    let valueList = objTree.GetValueListForChild("filter2", false);
    if (valueList == null) {
      valueList = objTree.GetValueListForChild("filter", false);
      this.fFilterDataCheckState = StringToBool(valueList[0]);
      var curFilterField = ConvertNull(valueList[1]);
      var curFilterComp = ConvertNull(valueList[2]);
      var curFilterVal = ConvertNull(valueList[3]);
      var includeSubsState = parseInt(valueList[4]);
    } else {
      this.fFilterDataCheckState = StringToBool(valueList[0]);
      var curFilterField = ConvertNull(valueList[1]);
      var curFilterComp = ConvertNull(valueList[2]);
      var includeSubsState = parseInt(valueList[3]);
      var curFilterVal = objTree.GetValueForChild("filterval", false);
    }

    if (valueList == null) return;

    var chainLevels = objTree.GetValueForChild("chain", true);

    var includeFiltered = objTree.GetValueForChild("includef", false);
    if (includeFiltered) includeFiltered = StringToBool(includeFiltered);

    filterRule.InitRule(includeSubsState, chainLevels, includeFiltered);

    var complex = objTree.GetValueForChild("complex", false);
    if (StringToBool(complex)) filterRule.SetRuleCriteria("Complex Rule");
    else filterRule.SetRuleCriteria("Basic Rule");

    var complexdef = objTree.GetValueForChild("complexdef", false);
    if (complexdef) filterRule.SetComplexDef(complexdef);

    if (curFilterField) {
      filterRule.AddRulePair(curFilterField, curFilterField, "Box", curFilterComp, curFilterVal);
    }

    this.fFilterRule = filterRule;

    /*
  var complexsub = objTree.GetValueForChild("complexsub", false);
  if (complexsub) this.fComplexSubFilter = StringToBool(complexsub);
  else this.fComplexSubFilter = false;

  var complexsubdef = objTree.GetValueForChild("complexsubdef", false);
  if (complexsubdef) this.fComplexSubFilterDef = complexsubdef;
  else this.fComplexSubFilterDef = "";
  */
  }

  LoadRefreshOptions(valueList, version) {
    this.fPersistBranchStyle = StringToBool(valueList[0]);
    this.fPersistBoxLayout = StringToBool(valueList[1]);
    this.fPersistAssist = StringToBool(valueList[2]);
    this.fPersistSubchartBreak = StringToBool(valueList[3]);
    if (version == "refresh2") this.fPersistBoxSort = this.fPersistBranchStyle;
    else this.fPersistBoxSort = StringToBool(valueList[4]);
  }

  LoadCTemplate(objTree) {
    var ctemplate = objTree.GetValueForChild("ctemplate2", false);
    if (ctemplate != null) {
      this.fChartTemplateName = ConvertNull(ctemplate);
      var ctemplateset = objTree.GetValueForChild("ctemplateset", true);
      this.fChartTemplateSet = ctemplateset;
    } else {
      var valueList = objTree.GetValueListForChild("ctemplate", false);
      var vlen = valueList.length;
      this.fChartTemplateName = ConvertNull(valueList[0]);
      var ts = parseInt(valueList[vlen - 1]);
      if (ts != enumChartTemplateSet.systemtemplates && ts != enumChartTemplateSet.sharedtemplates)
        ts = enumChartTemplateSet.sharedtemplates;
      this.fChartTemplateSet = ts;
    }
  }

  LoadSubElements(objTree) {
    var valueList = objTree.GetValueListForChild("conninfo", false);
    this.fSrcConnector = parseInt(valueList[0]);
    this.fSrcFile = ConvertNull(valueList[1]);
    this.fSrcDir = ConvertNull(valueList[2]);

    var adpProfile = objTree.GetValueForChild("profileadp", false);
    if (adpProfile) {
      this.fProfileADP = adpProfile;
      this.SetSelectedADPProfile(adpProfile);
    } else this.fProfileADP = "Default";

    this.LoadFilter(objTree);

    var topboxinfo = objTree.GetValueListForChild("topbox", false);
    if (topboxinfo) {
      this.fTopBoxCheckState = StringToBool(topboxinfo[0]);
      this.fTopBoxIDs = ConvertNull(topboxinfo[1]);
      if (this.fTopBoxIDs) this.fTopBoxIDs = this.fTopBoxIDs.split("^");
    }

    valueList = objTree.GetValueListForChild("subchart", false);
    this.fSubChartOption = ConvertNullInt(valueList[0]);
    this.fCurSubChartBreakLevels = ConvertNull(valueList[1]);
    this.fCurSubChartBreakField = ConvertNull(valueList[2]);
    this.fCurSmartBreak = ConvertNull(valueList[3]);
    this.fCurSubChartNameFieldID = ConvertNull(valueList[4]);
    this.fSmartStartLevel = ConvertNull(valueList[5]);

    //	var autoBreak = objTree.GetValueForChild("autobreak",false);
    //	if (autoBreak)
    //	   this.fAutoBreak =  StringToBool(autoBreak);
    var pageDensity = objTree.GetValueForChild("scdense", true);
    if (pageDensity) this.fPageDensity = pageDensity;

    var mapping = objTree.GetValueForChild("mapping");
    if (mapping != null) {
      //New system.
      this.fMapping = JSON.parse(mapping);
      var useHier = objTree.GetValueForChild("usehier");
      if (useHier) this.fHierCheckState = useHier;
    } else {
      //legacy (pre 5.1.2) mapping handling
      valueList = objTree.GetValueListForChild("reqfields", false);
      var v0 = ConvertNull(valueList[0]);
      this.SetIDField(CommaDecode(v0));
      var v1 = ConvertNull(valueList[1]);
      this.SetSuperField(CommaDecode(v1));
      var v2 = ConvertNull(valueList[2]);
      this.SetNameField(CommaDecode(v2));
      var v3 = ConvertNull(valueList[3]);
      this.SetTitleField(CommaDecode(v3));
      this.fHierCheckState = StringToBool(valueList[4]);
      valueList = objTree.GetValueListForChild("photo", false);
      if (valueList) this.SetPhotoField(ConvertNull(valueList[0]));
    }

    var useAssistRule = objTree.GetValueForChild("useassistrule", false);
    if (useAssistRule) this.fUseAssistantRule = StringToBool(useAssistRule);
    var archiveDate = objTree.GetValueForChild("archivedate", false);
    if (archiveDate) this.fArchiveTimeStamp = archiveDate;
    var usePeerAssistRule = objTree.GetValueForChild("usepeerassistrule", false);
    if (usePeerAssistRule) this.fUsePeerAssistRule = StringToBool(usePeerAssistRule);
    var startAssistLeft = objTree.GetValueForChild("assistleft", false);
    if (startAssistLeft) this.fStartAssistLeft = StringToBool(startAssistLeft);

    var assistMode = objTree.GetValueForChild("assistmode", false);
    if (assistMode) this.fAssistWizMode = parseInt(assistMode);
    else
      this.fAssistWizMode = this.fUseAssistantRule
        ? enumAssistOption.byrule
        : enumAssistOption.byfield;

    var doAuxReporting = objTree.GetValueForChild("doauxreporting", false);
    if (doAuxReporting) this.fDoAuxReporting = StringToBool(doAuxReporting);

    var coheadchart = objTree.GetValueForChild("cohead", false);
    if (coheadchart) this.fCoHeadChart = StringToBool(coheadchart);

    var sortchart = objTree.GetValueForChild("sortchart", false);
    if (sortchart) this.fSortChart = StringToBool(sortchart);
    else this.fSortChart = false;

    valueList = objTree.GetValueListForChild("reftable", false);
    if (valueList) {
      this.fUseRefTable = StringToBool(valueList[0]);
      this.fRefTableFile = ConvertNull(valueList[1]);
    } else this.fUseRefTable = false;

    valueList = objTree.GetValueListForChild("appenddata", false);
    if (valueList) {
      this.fAppendData = StringToBool(valueList.shift());
      this.fAppendFile = ConvertNull(valueList.join(","));
    } else this.fAppendData = false;

    var chartBuilderParams = objTree.GetValueListForChild("chartbuilderparams", false);
    if (chartBuilderParams != null) {
      var jobj = JSON.parse(chartBuilderParams);
      var chartID = jobj["chartID"];
      this.SetBaseChartID(chartID);
      this.fChartLevels = jobj["levels"];
      this.fChainLevels = jobj["chainLevels"];

      //TODO: Some filter info in here too
      //store filters?
      //store chain of command
      //this.fChartBuilderParams  = ConvertNull(jobj);
    }

    var placeHolder = objTree.GetValueListForChild("placeholder", false);
    if (placeHolder) {
      this.fPlaceHolder = StringToBool(placeHolder);
    } else this.fPlaceHolder = false;

    valueList = objTree.GetValueListForChild("placeholderfields", false);
    if (valueList) {
      this.fPlaceHolderField = ConvertNull(valueList[0]);
      this.fPlaceHolderField2 = ConvertNull(valueList[1]);
    } else {
      this.fPlaceHolderField = null;
      this.fPlaceHolderField2 = null;
    }

    valueList = objTree.GetValueForChild("restrict", false);
    if (valueList) {
      this.fRestrictData = StringToBool(valueList);
    } else this.fRestrictData = false;

    valueList = objTree.GetValueListForChild("restrictdata", false);
    if (valueList) {
      this.fRestrictFields = ConvertNull(valueList);
    } else this.fRestrictFields = false;

    var sapOption = objTree.GetValueForChild("sapoption", true);
    if (sapOption) this.fSAPOptions = sapOption;

    this.LoadCTemplate(objTree);

    valueList = objTree.GetValueListForChild("master", false);
    this.fMPOption = parseInt(valueList[0]);
    this.fCurMPFile = ConvertNull(valueList[1]);
    this.fCurMPFolder = ConvertNull(valueList[2]);

    var valueList = objTree.GetValueListForChild("refresh3", false);
    if (valueList) this.LoadRefreshOptions(valueList, "refresh3");
    else {
      var valueList = objTree.GetValueListForChild("refresh2", false);
      if (valueList != null) this.LoadRefreshOptions(valueList, "refresh2");
      else {
        var refreshOption = objTree.GetValueForChild("refresh", true);
        if (refreshOption != null) this.MapRefreshOption(refreshOption);
      }
    }
  }

  LoadChildElements(objTree) {
    var sortPrefs = objTree.GetChildByName("qsortconfig");
    if (sortPrefs) {
      this.fSortCriteria = new QSortConfig();
      this.fSortCriteria.LoadFromXML(sortPrefs);
    }

    var assistRule = objTree.GetChildByName("rule");
    if (assistRule) {
      var theRule = new QAssistantRule();
      theRule.InitAssistantRule("rule");
      theRule.LoadFromXML(assistRule);
      this.fAssistantRule = theRule;
    }

    var assistRule = objTree.GetChildByName("peerrule");
    if (assistRule) {
      var theRule = new QAssistantRule();
      theRule.InitAssistantRule("peerrule");
      theRule.LoadFromXML(assistRule);
      this.fPeerAssistRule = theRule;
    }
  }

  OutputChildElements(stream) {
    if (this.fSortCriteria) this.fSortCriteria.OutputToXML(stream);

    if (this.fAssistantRule) this.fAssistantRule.OutputToXML(stream);

    if (this.fPeerAssistRule) this.fPeerAssistRule.OutputToXML(stream);
  }
}
